import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import LocationSelect from '@lib/components/LocationSelect/LocationSelect';
import {
  isWidgetSelected,
  getConditionalLocationValidation,
} from './validationHelpers';

/**
 * Returns fields for Weather Today widget
 */
export default function getWeatherTodayFields(t: TFunction): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.WeatherTodayInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-weather-today-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.WeatherToday),
    },
    {
      name: WidgetFieldNames.WeatherTodayLocation,
      label: t('location'),
      element: LocationSelect,
      componentProps: {
        usePortal: true,
      },
      validation: getConditionalLocationValidation(
        t,
        WidgetsKindEnum.WeatherToday,
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.WeatherToday),
    },
  ];
}
